<div>
  
  <h1 class="main-title">
    <div class="circle circle-primary">
      <img src="assets/icons/toolbox-icon.svg" alt="">
    </div>
    Mantenciones
  </h1>
  <div class="flex justify-between items-center mb-2">
    <h2 class="main-subtitle">Todas las mantenciones</h2>
    <a routerLink="/maintenances/create" class="button button-success">
      <i class="fa-solid fa-plus" alt=""></i> Nueva Mantención
    </a>
  </div>

  <div class="single-page-content">
    <!-- <div class="flex justify-between items-center mb-4"> -->
      <!-- <button class="button button-primary button-sm">
        Filtrar <i class="fa-solid fa-filter" alt=""></i>
      </button> -->
      <!-- <input type="search" class="input max-w-72" placeholder="Buscar por ID o Nombre"> -->
    <!-- </div> -->
    <app-table [columns]="tableColumns" [data]="flattenedData">
      <ng-template #actionTemplate let-maintenance>
        <div class="action-buttons">
          <!--
          <a (click)="selectMaintenance(maintenance)" class="text-blue-600 focus:outline-none cursor-pointer">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M13.5 6c-2.88 0-5.5 2.62-5.5 5.5s2.62 5.5 5.5 5.5 5.5-2.62 5.5-5.5-2.62-5.5-5.5-5.5zm0 9.5c-2.07 0-3.75-1.68-3.75-3.75S11.43 7 13.5 7s3.75 1.68 3.75 3.75-1.68 3.75-3.75 3.75z"/>
            </svg>
          </a>
          -->
          <a routerLink="/maintenances/update/{{maintenance.id}}" title="Editar">
            <img src="assets/icons/pencil-icon.svg" alt="">
          </a>
          <button (click)="confirmDelete(maintenance)" title="Eliminar">
            <img src="assets/icons/trashcan-icon.svg" alt="">
          </button>
          <!--
          <button (click)="toggleMaintenanceStatus(maintenance)" class="text-yellow-600 focus:outline-none">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path *ngIf="maintenance.disabled" d="M12 17c-1.1 0-2-.9-2-2v-2h2v2h8v-2h2v2c0 1.1-.9 2-2 2h-8zm6-10v-2c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2h8zm-2 0h-4v-2h4v2z"/>
              <path *ngIf="!maintenance.disabled" d="M20 8h-2V6c0-2.76-2.24-5-5-5S8 3.24 8 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-4-2c0-1.66-1.34-3-3-3s-3 1.34-3 3v2h6V6zm-3 12h-4v-2h4v2zm0-4h-4v-2h4v2z"/>
            </svg>
          </button>
          -->
        </div>
      </ng-template>
    </app-table>

    <app-confirm-popup 
      *ngIf="maintenanceToDelete" 
      [message]="'¿Estás seguro de que quieres eliminar esta mantención?'" 
      (onConfirm)="onDeleteConfirm()" 
      (onCancel)="onDeleteCancel()"></app-confirm-popup>
  </div>
</div>
